import type { TedCpvCode } from '../../../services/service-sales';
import { ChecklistGroup, ChecklistOption, matchesLabel } from '../../bt-checklist-select/checklist';

export const cpvSections = (codes: readonly TedCpvCode[]): ChecklistGroup[] => {
  const sections: ChecklistGroup[] = [];
  const byDivision = new Map<string, ChecklistGroup>();
  codes.forEach(entry => {
    let section = byDivision.get(entry.division);
    if (!section) {
      section = { value: entry.division, label: `${entry.division} ${entry.divisionLabel}`, options: [] };
      byDivision.set(entry.division, section);
      sections.push(section);
    }
    section.options.push({ value: entry.code, label: `${entry.code} – ${entry.label}` });
  });
  return sections;
};

// Procurement documents print a code with its check digit, as in 45233140-7.
const CODE_QUERY = /^(\d+)(-\d?)?$/;

/** Digits name a branch of the CPV hierarchy, so they match from the start of a code. */
export const matchesCpvQuery = (option: ChecklistOption, query: string) => {
  const code = CODE_QUERY.exec(query.trim());
  return code ? option.value.startsWith(code[1]) : matchesLabel(option, query);
};
